define(["require", "exports", "../utils/utils", "./ColorPicker", "./OptionsStyleTool", "./RangeTool"], function (require, exports, utils_1, ColorPicker_1, OptionsStyleTool_1, RangeTool_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.capitalize = exports.StyleTools = void 0;
    exports.StyleTools = [
        {
            match: new RegExp(/\-color$/),
            toolFactory: (viewer, id, defaultValue, changeHandler) => {
                return new ColorPicker_1.ColorPicker(viewer, id, defaultValue, changeHandler);
            },
        },
        {
            match: new RegExp(/\-size$/),
            toolFactory: (viewer, id, defaultValue, changeHandler) => {
                return new RangeTool_1.RangeTool(viewer, id, defaultValue, changeHandler, 0, 1);
            },
        },
        {
            match: new RegExp(/\-width/),
            toolFactory: (viewer, id, defaultValue, changeHandler) => {
                return new RangeTool_1.RangeTool(viewer, id, defaultValue, changeHandler, 0, 1);
            },
        },
        {
            match: new RegExp(/\-opacity/),
            toolFactory: (viewer, id, defaultValue, changeHandler) => {
                return new RangeTool_1.RangeTool(viewer, id, defaultValue, changeHandler, 0, 1);
            },
        },
        {
            match: new RegExp(/\-weight/),
            toolFactory: (viewer, id, defaultValue, changeHandler) => {
                if (!utils_1.isNumeric(defaultValue)) {
                    switch (defaultValue) {
                        case 'bold':
                            defaultValue = 700;
                            break;
                        default:
                            defaultValue = 400;
                    }
                }
                return new RangeTool_1.RangeTool(viewer, id, defaultValue, changeHandler, 1, 1000);
            },
        },
        // {
        //     match: 'stroke-linejoin',
        //     toolFactory: ((viewer: Autodesk.Viewing.Viewer3D, id: string, defaultValue: any, changeHandler: (value: any) => void) => {
        //         const tool = new OptionsStyleTool(viewer, id, defaultValue, changeHandler, {
        //             'arcs': 'Arcs',
        //             'bevel': 'Bevel',
        //             'miter': 'Miter',
        //             'miter-clip': 'Miter Clip',
        //             'round': 'Round',
        //         });
        //         return tool;
        //     })
        // },
        {
            match: 'font-family',
            toolFactory: (viewer, id, defaultValue, changeHandler) => {
                return new OptionsStyleTool_1.OptionsStyleTool(viewer, id, defaultValue, changeHandler, {
                    serif: 'Serif',
                    'sans-serif': 'Sans Serif',
                    monospace: 'Monospace',
                    ArtifaktElement: 'Artifakt',
                });
            },
        },
        {
            match: 'font-style',
            toolFactory: (viewer, id, defaultValue, changeHandler) => {
                return new OptionsStyleTool_1.OptionsStyleTool(viewer, id, defaultValue, changeHandler, {
                    normal: 'Normal',
                    italic: 'Italic',
                    oblique: 'Oblique',
                });
            },
        },
    ];
    const capitalize = (s) => {
        if (typeof s !== 'string') {
            return '';
        }
        return s.charAt(0).toUpperCase() + s.slice(1);
    };
    exports.capitalize = capitalize;
});
//# sourceMappingURL=StyleTools.js.map